import { Payment_Gateway_Enum } from "./portal";

export const COMING_SOON_GATEWAYS: string[] = [
    Payment_Gateway_Enum.btcpay,
    Payment_Gateway_Enum.paypal
];

export const isGatewayComingSoon = (gateway: string): boolean => {
    if (!gateway) return false;
    return COMING_SOON_GATEWAYS.some(g => g.toLowerCase() === gateway.toLowerCase());
};
